import { FormattedMessage } from 'react-intl';
import { Hyperlink } from 'components/ui/atoms/link';

export const EmptyCartCard = () => (
  <div className="card">
    <div className="card-body">
      <h1 className="h5 card-title">
        <FormattedMessage
          id="payment.empty.cart.heading"
          defaultMessage="Your cart is empty."
          description="The heading displayed when there is no cart"
        />
      </h1>
      <p className="card-text" data-testid="empty-cart-message">
        <FormattedMessage
          id="payment.empty.cart.message"
          defaultMessage="If you attempted to make a purchase, you have not been charged. Return to your {actionLinkOne} to try again, or {actionLinkTwo}."
          description="The message displayed when there is no cart. Action links will redirect to dashboard or support page"
          values={{
            actionLinkOne: (
              <Hyperlink
                destination={process.env.NEXT_PUBLIC_EDX_LEARNER_DASHBOARD_URL}
              >
                <FormattedMessage
                  id="payment.empty.cart.dashboardURL"
                  defaultMessage="dashboard"
                  description="The message displayed on the redirect to dashboard link"
                />
              </Hyperlink>
            ),
            actionLinkTwo: (
              <Hyperlink destination={process.env.NEXT_PUBLIC_EDX_SUPPORT_URL}>
                <FormattedMessage
                  id="payment.empty.cart.supportURL"
                  defaultMessage="contact edX E-commerce Support"
                  description="The message displayed on the redirect to support page link"
                />
              </Hyperlink>
            ),
          }}
        />
      </p>
    </div>
  </div>
);
